/**
 * DASHBOARD-PARTICIPATION-PROGRESS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-participation-progress-animated.widget.tsx : silhouette
 * de barres décroissantes (forme typique d'une courbe de participation qui s'essouffle),
 * même hauteur (350px) que le vrai graphique pour éviter tout saut de layout.
 */
import Skeleton from "@/components/skeleton"

//Hauteurs (% de la zone de tracé) qui rappellent une participation qui démarre fort puis s'essouffle
const BAR_HEIGHTS = [72, 46, 22, 12, 8, 8, 26, 16, 8, 8]
const PLOT_HEIGHT = 260

export default function DashboardParticipationProgressSkeletonWidget() {
  return (
    <div style={{ height: 350, padding: "20px 30px 40px" }} className="flex flex-dcol">
      <div className="flex1 flex items-end" style={{ gap: 8 }}>
        {BAR_HEIGHTS.map((h, i) => (
          <div key={i} className="flex1" style={{ display: "flex", justifyContent: "center" }}>
            <Skeleton width={24} height={(h / 100) * PLOT_HEIGHT} borderRadius="4px 4px 0 0" />
          </div>
        ))}
      </div>
      <div className="height-20" />
      <Skeleton width="100%" height={1} />
    </div>
  )
}
